module.exports = __webpack_public_path__ + "static/img/5.47baa2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/eng/5.png
// module id = YUlU
// module chunks = 0